export default {
  apps: {
    add: 'add_app',
    list: 'list_apps',
  },
  games: {
    list: 'list_games',
    view_add_button: 'view_add_game',
  },
};
